import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Grid, Dimmer, Loader} from 'semantic-ui-react';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import {Actions} from '../../../common/actions';

class Output extends Component {
  componentDidMount() {
    const {chassis} = this.props;
    this.props.fetchOutputDataByChassis(chassis);
  }

  renderLoader = () => {
    const {loading} = this.props;
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Consultando...' />
        </Dimmer>
      );
    }
  };

  renderColumn = (width, type, text = '') => {
    if (type === 'label' && !text) {
      return;
    }
    return (
      <Grid.Column width={width}>
        {type === 'label' ? <h4>{text}:</h4> : `${text}`}
      </Grid.Column>
    );
  };

  render() {
    const {outputData} = this.props;
    const invoicingDateFormatted = outputData.invoicingDate ?
      moment(outputData.invoicingDate).format(dateFormatShow) : '';

    return (
      <div className='title-bar'>
        {this.renderLoader()}
        <div className='filters-section'>
          <Grid textAlign='left'>
            <Grid.Row>
              {this.renderColumn(2, 'label', 'Factura')}
              {this.renderColumn(3, 'value', outputData.invoice)}
              {this.renderColumn(2, 'label', 'Cliente')}
              {this.renderColumn(3, 'value', outputData.clientName)}
              {this.renderColumn(2, 'label', 'Combo')}
              {this.renderColumn(3, 'value', outputData.comboCode)}
            </Grid.Row>
            <Grid.Row>
              {this.renderColumn(2, 'label', 'F. Facturación')}
              {this.renderColumn(3, 'value', invoicingDateFormatted)}
              {this.renderColumn(2, 'label', 'Reservado Para')}
              {this.renderColumn(3, 'value', outputData.reservedFor)}
              {this.renderColumn(2, 'label', 'Hunter')}
              {this.renderColumn(3, 'value', outputData.hunter)}
            </Grid.Row>
            <Grid.Row>
              {this.renderColumn(2, 'label', 'Tipo Orden Venta')}
              {this.renderColumn(3, 'value', outputData.saleType)}
              {this.renderColumn(2, 'label', 'Tipo Doc Venta')}
              {this.renderColumn(3, 'value', outputData.saleDocumentType)}
              {this.renderColumn(2, 'label', 'N. Doc Venta')}
              {this.renderColumn(3, 'value', outputData.saleDocumentNumber)}
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.vehicleHistory.loading,
    'outputData': state.vehicleHistory.outputData,
  };
};

const {fetchOutputDataByChassis} = Actions;

export default connect(mapStateToProps, {
  fetchOutputDataByChassis,
})(Output);
